// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"c097e7f2","200":"fbbda139","729":"a1c40c77","900":"4ba72142","925":"682f12a7","991":"a1a6f3c5"}[chunkId] + ".chunk.js";
};